export default __webpack_public_path__ + "static/media/b7.6da1dd1f.jpg";